"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var CardRequirementsComponent_vue_1 = require("./CardRequirementsComponent.vue");
var CardVictoryPoints_vue_1 = require("./CardVictoryPoints.vue");
var CardDescription_vue_1 = require("./CardDescription.vue");
var CardRenderData_vue_1 = require("./CardRenderData.vue");
exports.default = vue_1.default.extend({
    name: 'CardContent',
    props: {
        metadata: {
            type: Object,
            required: true,
        },
        requirements: {
            type: Object,
        },
        isCorporation: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        CardRequirementsComponent: CardRequirementsComponent_vue_1.default,
        CardVictoryPoints: CardVictoryPoints_vue_1.default,
        CardDescription: CardDescription_vue_1.default,
        CardRenderData: CardRenderData_vue_1.default,
    },
    methods: {
        getClasses: function () {
            var classes = ['card-content'];
            if (this.isCorporation) {
                classes.push('card-content-corporation');
            }
            return classes.join(' ');
        },
    },
});
